<script>
export default {
  /**
   *
   *
   */
  props: {
    columns: {
      default: () => [],
    },
    data: {
      default: () => [],
    },
    showIndex: {
      type: Boolean,
      default: true
    },
    selection: Boolean,
    pages: {
      default: () => ({
        "page-size": 20,
        "current-page": 1,
        "total": 0,
      }),
    },
    layout: {
      default: () => "sizes, prev, pager, next, jumper, total"
    }
  },
  data() {
    return {};
  },
  methods: {
    renderColumn(h, item) {
      const scopedSlots = {
        default(scope) {
          return typeof item.render === "function"
            ? item.render(h, scope)
            : scope.row[item.prop];
        },
      };
      return (
        <el-table-column
          show-overflow-tooltip
          {...{ props: item }}
          {...{ scopedSlots }}
        ></el-table-column>
      );
    },
    renderPage() {
      if (this.pages) {
        return (
          <div class="page mt-10 flex-none">
            <el-pagination
              background
              layout={this.layout}
              props={this.pages.props}
              on={this.pages.on}
            ></el-pagination>
          </div>
        );
      }
    },
  },
  render(h) {
    return (
      <div class="table flex layout" style="height:100%">
        <el-table
          border
          height="100%"
          row-key="id"
          ref="table"
          header-cell-class-name="tableheaderclass"
          class="table flex layout"
          data={this.data}
          {...{ props: this.$attrs }}
          {...{ on: this.$listeners }}
        >
          {this.selection && <el-table-column type="selection" width="55"></el-table-column>}
          {this.columns.map((item) => this.renderColumn(h, item))}
          <el-table-column resizable={false} width={1}></el-table-column>
        </el-table>
        {this.renderPage()}
      </div >
      //  {this.showIndex && <el-table-column type="index" label="序号" width="60"></el-table-column>} 79
    );
  },
};
</script>
<style scoped lang="scss">
.table {
  // width: 100%;
  flex-direction: column;
  overflow: auto;
  ::v-deep {
    .el-table {
      overflow: auto;
      .el-table__header-wrapper{
        flex-shrink: 0;
      }
      th > .cell {
        text-align: left;
      }

      .cell {
        text-align: left;
        white-space: nowrap;

        & > div {
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      thead {
        color: #111111;
        font-size: 14px;
        th {
          background-color: #f6f7fb;
        }
      }
      td {
        padding: 0;
        color: rgba(0, 0, 0, 0.87);
      }
      th,
      tr {
        height: 40px;
        font-weight: normal;
      }
    }
  }
  .ell {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .page {
    margin-top: 20px;
    text-align: right;
  }
  //::v-deep  .bg {
  //  background: #ffffff;
  //}
  .canClick {
    cursor: pointer;
    color: #108cee;
  }
  .index {
    position: relative;
    width: 30px;
    height: 30px;
    display: inline-block;
    text-align: center;
  }
  //.warning::after {
  //  content: "";
  //  display: block;
  //  position: absolute;
  //  left: 0;
  //  top: 0;
  //  width: 18px;
  //  height: 18px;
  //  background: url("../assets/logo.png") no-repeat;
  //  background-size: 100% 100%;
  //}
}
</style>
